import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchChatTags = ({ accountId }) => get(`/accounts/${accountId}/chat-tags`);

export const addChatTag = ({ accountId, tag }) => post(`/accounts/${accountId}/chat-tags`, tag);

export const updateChatTag = ({ accountId, tagId, tag }) => patch(`/accounts/${accountId}/chat-tags/${tagId}`, tag);

export const deleteChatTag = ({ accountId, tagId }) => httpDelete(`/accounts/${accountId}/chat-tags/${tagId}`);
